import React from "react"
import L10n from "lib/carrot-l10n"
import Title from "../Title"
import Wrapper from "components/views/Wrapper"
import { Spacer, HR } from "components/views/atoms/Atoms"
import { IlloCircleCarrotCards } from "../atoms/Illustrations"
import { FlexRowCenter } from "../atoms/Atoms"
import { Body } from "../atoms/Bodies"
import { ButtonPrimary } from "../atoms/buttons/ButtonPrimary"
import { getIsUsa } from "reducers/userInfo"
import { useSelector } from "react-redux"
import { MasterLayout } from "components/views/atoms/layouts/MasterLayout"
import RequestCardHeader from "components/views/requestcard/RequestCardHeader"
import { BodyWithRightSidebarLayout } from "components/views/atoms/layouts/BodyWithRightSidebarLayout"
import RequestCardWizardHeader from "components/views/requestcard/RequestCardWizardHeader"
import { ArrowLink } from "components/views/atoms/links/ArrowLink"
import { TextLink } from "components/views/atoms/links/TextLink"
import { getSupportCenterLink, SupportCenterLinks } from "utils/SupportCenterLinks"
import { FeatureGate } from "utils/FeatureGate"
import { H2 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

// view component immediately after successfully completing carrot card activation
const RequestCardSuccess = () => {
  const isUsa = useSelector(getIsUsa)

  return isUsa ? <RequestPhysicalCardSuccess /> : <RequestVirtualCardSuccess />
}

const RequestVirtualCardSuccess = () => (
  <MasterLayout header={<RequestCardHeader backRoute="/request-card/phone-verification" />}>
    <Title title={l`carrotCard.getYourCarrotCard`} />
    <BodyWithRightSidebarLayout>
      <RequestCardWizardHeader>
        <span id="request-card-virtual-success-header">{l`Your virtual Carrot Card is ready to use. `}</span>
      </RequestCardWizardHeader>
      <Spacer height={0.5} />
      <Body color="black-80">
        {l`You’ll receive an email and an SMS confirming this with some important information about using your virtual Carrot Card. Your card number, security code, expiration, and billing address can be `}
        <TextLink to="/transactions#card-details">{l`found here`}</TextLink>.
      </Body>
      <FeatureGate filter={(c) => c.isSupportCenterEnabled}>
        <Spacer height={2} />
        <ArrowLink
          target="_blank"
          to={getSupportCenterLink(SupportCenterLinks.CARROT_CARD_SUPPORT_CENTER)}
          color="black-60"
        >{l`How do I pay for care with a virtual card?`}</ArrowLink>
        <Spacer height={0.25} />
        <ArrowLink
          target="_blank"
          to={getSupportCenterLink(SupportCenterLinks.CARROT_CARD_SUPPORT_CENTER)}
          color="black-60"
        >{l`What happens if my provider won’t accept virtual cards?`}</ArrowLink>
        <Spacer height={0.25} />
        <ArrowLink
          target="_blank"
          to={getSupportCenterLink(SupportCenterLinks.CARROT_CARD_SUPPORT_CENTER)}
          color="black-60"
        >{l`Browse all virtual card support articles`}</ArrowLink>
      </FeatureGate>

      <Spacer height={2} />
      <div className="flex justify-end">
        <ButtonPrimary to="/transactions#card-details">{l`Done`}</ButtonPrimary>
      </div>
      <Spacer height={1.5} />
      <HR color="black-20" />
    </BodyWithRightSidebarLayout>
  </MasterLayout>
)

const RequestPhysicalCardSuccess = () => (
  <Wrapper medium>
    <div className="flex">
      <div className="mw6 center">
        <Title title={l`carrotCard.getYourCarrotCard`} />
        <FlexRowCenter>
          <IlloCircleCarrotCards />
        </FlexRowCenter>
        <Spacer height={2} />
        <H2>{l`carrotCard.request.cardIsBeingPrepared`}</H2>
        <Spacer height={0.5} />
        <Body color="black-80">{l`carrotCard.request.successInstructions`}</Body>
        <Spacer height={2} />
        <div className="flex flex-row justify-end">
          <ButtonPrimary to="/transactions">{l`carrotCard.request.gotIt`}</ButtonPrimary>
        </div>
        <Spacer height={3} />
        <HR color="light-gray" />
      </div>
    </div>
  </Wrapper>
)

export default RequestCardSuccess
